import { render, staticRenderFns } from "./PdfDownload.vue?vue&type=template&id=47dcf382"
import script from "./PdfDownload.vue?vue&type=script&lang=js"
export * from "./PdfDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports